import LabelTableCell from 'Components/LabelTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import TranslatedField from 'Components/TranslatedField'
import type { ParameterGroupParameter } from 'Services/ProductManagement/Features/Parameter/types'
import { showValueOrHyphen } from 'Util/formatters'
import { Paper, styled, Table, TableBody, TableCell, TableContainer } from '@mui/material'
import { t } from 'ttag'

const StyledTableCell = styled(LabelTableCell)`
  width: 40%;
`

interface ParameterDetailsProps {
  parameterGroupParameter: ParameterGroupParameter
}

export function ParameterDetails({ parameterGroupParameter }: Readonly<ParameterDetailsProps>) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ td: { border: 'none' } }} aria-label={t`Parameter details table`}>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>{t`Identifier`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(parameterGroupParameter.parameter_id)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Name`}</StyledTableCell>
            <TableCell>
              <TranslatedField
                key="parameter-name"
                field="value"
                translations={parameterGroupParameter.translations}
              />
            </TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
